<ng-container>
    <sl-home [editLayoutDefaultSettingsRoleId]="this.roleId" [layoutKey]="LayoutKeyEnum.GeneralMeeting" />
</ng-container>
